<script setup>
import Sortable from "sortablejs";
import {defineEmits, defineProps, watch, ref} from "vue";

const emits = defineEmits(["change"]);

const props = defineProps({
  id: {
    type: String,
    required: true,
  },
  processing: { type: Boolean, default: false },
  isTable: { type: Boolean, default: true }
});

const sortable = ref(null)

const container = ref();

watch(() => container.value, (value, oldValue) => {
  if(value !== oldValue) {
    if(sortable.value) {
      sortable.value.destroy()
    }
    InitSortable();
  }
})

function InitSortable() {
  if (!container.value) {
    return false;
  }
  sortable.value = new Sortable(container.value, {
    draggable: ".draggable",
    handle: ".draggable-handle",
    animation: 150,
    onEnd: (event) => {
      if(event) {
        let oldIndex = event.oldDraggableIndex;
        let newIndex = event.newDraggableIndex;
        emits("change", { oldIndex, newIndex });
      }
    },
  });
}


</script>

<template>
  <div v-if="!isTable" :ref="el => container = el" class="position-relative">
    <div v-if="processing" class="position-absolute h-100 w-100 d-flex justify-content-center align-items-center" style="background-color: white;  opacity: .5" >
      <span class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Loading...</span>
      </span>
    </div>
    <slot />
  </div>
  <tbody v-if="isTable" :ref="el => container = el" class="position-relative">
    <div v-if="processing" class="position-absolute h-100 w-100 d-flex justify-content-center align-items-center" style="background-color: white;  opacity: .5" >
      <span class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Loading...</span>
      </span>
    </div>
    <slot />
  </tbody>
</template>

<style scoped>

</style>